import { IDoPos, IScore } from "../../../../../common/types";
import { getNewDoPosOctave } from "../../components/ChangeKey/utils";
import { parseDo } from "../../methods/changeDo";

const getAccidental = (score: IScore) => {
    return score.doPos ? score.doPos.i : 0;
};

const getKeyOctave = (score: IScore) => {
    return score.doPos ? score.doPos.o : 4;
};

export interface IAccidental {
    i: IDoPos["i"],
    o: IDoPos["o"],
    isVisible: boolean,
    previousI?: IDoPos["i"],
}

export const getAccidentals = (score: IScore) => {
    let longestBars = score.bars;
    const keyChanges = score.keyChanges || [];
    for (let b = 1; b <= 5; b++) {
        if (score["bars" + b] && score["bars" + b].length > longestBars.length) {
            longestBars = score["bars" + b];
        }
    }
    let accidentals: IAccidental[] = [];
    let currentAccidental: IDoPos["i"] = getAccidental(score);
    let currentOctave: IDoPos["o"] = getKeyOctave(score);
    for (let b = 0; b < longestBars.length; b++) {
        const keyChange = keyChanges.find(kc => kc.bar === b);
        const previousAccidental = currentAccidental;
        if (keyChange) {
            currentAccidental = (currentAccidental + keyChange.amount) as IDoPos["i"];
            const currentParsedDoPos = parseDo({
                i: previousAccidental,
                o: currentOctave,
            });
            const newDoPos = parseDo({
                i: currentAccidental,
                o: currentOctave,
            });
            const autoDirection: 1 | -1 | 0 = currentParsedDoPos.value === newDoPos.value ? 0 : currentParsedDoPos.value < newDoPos.value ? 1 : -1;
            currentOctave = getNewDoPosOctave(currentOctave, autoDirection, keyChange.direction);
        }
        accidentals[b] = {
            i: currentAccidental,
            o: currentOctave,
            isVisible: !!keyChange,
            ...(currentAccidental === 0 && {
                previousI: previousAccidental,
            })
        };
    }
    return accidentals;
}

export default getAccidental;
